import _ from 'lodash'

const getter = (dataPath, {clientSpec}) => _.get(clientSpec, dataPath)

export default getter
